import ScenariosNodeList from "../../components/Admins/ScenariosNodes/ScenariosNodeList";

export const ScenariosNodeListPage = ()=>{
    return (
        <ScenariosNodeList/>
    );
}
